<template>
<div class="swiper-slide-inner">
    <div class="step">
        <p>Installation</p>
    </div>

    <div class="card _finish">
        <div class="card-inner">

            <div class="question-wrap">
                <h3><span>仮設置完了</span></h3>
            </div>

            <div class="page-animation-wrap">

                <div class="md_page-element">
                    <div class="inner">
                        <div class="img-wrap">
                            <div class="img _no01"><div class="icon"><SvgIconImagePlace /></div></div>
                            <div class="img _no02"><div class="icon"><SvgIconImagePlace /></div></div>
                        </div>
                        <div class="text _heading"></div>
                        <div class="text _no01"></div>
                        <div class="text _no02"></div>
                        <div class="text _no03"></div>
                        <div class="btn-wrap">
                            <div class="btn _left _no01"></div>
                            <div class="btn _left _no02"></div>
                            <div class="btn _right _no03"></div>
                        </div>
                    </div>
                    <div class="bg"></div>
                </div>

            </div>

            <div class="question-wrap">
                <p>{{getName}}ページの仮設置が完了致しました。編集画面へお進みください。</p>
            </div>

        </div>

        <div class="control-wrap">
            <a href="#home" class="_right js-confirm-in" v-on:click="confirmIn()"><span>NEXT</span></a>
        </div>

    </div>

</div>
</template>

<script>

    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'
    import SvgIconImagePlace from '@/components/EndUser/svg/SvgIconImagePlace'
    export default {
        components: {
            SvgIconCheck,
            SvgIconImagePlace,
        },
        methods: {
            ////////////////////////////////////
            //会員登録画面の確認画面表示
            ////////////////////////////////////
            confirmIn: function () {
                //Swiperをフェードアウト
                $('.swiper-container').addClass('_hidden');
                setTimeout(() => {
                    //Swiperをdisplay:none;
                    $('.swiper-container').addClass('_none');
                }, 200);
                setTimeout(() => {
                    //確認画面のdisplay:none;を解除
                    $('.dply_detail-page').addClass('_block');
                }, 200);
                setTimeout(() => {
                    //確認画面をフェードイン
                    $('.dply_detail-page').addClass('_show');
                    //審査するボタンを表示
                    $('.btn_examination-wrap._preview').addClass('_show');
                }, 250);
            },
        },
        mounted:function () {
            $('a[href^="#"]').on('click', function(){
            var speed = 500;
            var href= $(this).attr("href");
            var target = $(href == "#" || href == "" ? 'html' : href);
            var position = target.offset().top;
            $("html, body").animate({scrollTop:position}, speed, "swing");
            return false;
            });
        },
        computed: {
            getName() {
                var url = location.pathname;
                if (url.indexOf( '/brand/step' ) != -1) {
                    return 'ブランド';
                } else if (url.indexOf( '/shop/step' ) != -1) {
                    return 'ショップ';
                } else if (url.indexOf( '/showroom/step' ) != -1) {
                    return 'ショールーム';
                }
            },
        }
    }
</script>

